module.exports = __webpack_public_path__ + "static/media/vkuss.35ed6746.png";